import ConfigureMainReport from "./ConfigureMainReport";

export default ConfigureMainReport;
